import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Whiteboard } from '../../types';
import { WhiteboardService } from '../../services/whiteboard.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../../services/auth/auth.service';
import { first, takeUntil, tap } from 'rxjs/operators';
import { WhiteboardManagementActionButtonConfigService } from '../../services/whiteboard-management-action-button-config.service';

@Component({
    selector: 'lib-whiteboard-management',
    templateUrl: './whiteboard-management.component.html',
    styleUrls: ['./whiteboard-management.component.scss'],
    standalone: false
})
export class WhiteboardManagementComponent implements OnInit, OnDestroy {

  protected whiteboardService = inject(WhiteboardService);
  protected authService = inject(AuthService);
  public actionButtonConfig = inject(WhiteboardManagementActionButtonConfigService);

  unsubscribe: Subject<void> = new Subject();

  whiteboards: Whiteboard[] = [];
  isAdmin = false;
  blockBtns = true;

  ngOnInit(): void {
    this.authService
      .getRoles()
      .pipe(
        first(),
        tap(roles => (this.isAdmin = roles.includes('ADMIN')))
      )
      .subscribe(_ => {});

    this.whiteboardService
      .getAll()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(whiteboards => (this.whiteboards = whiteboards));
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
